import Link from 'next/link';
import { NextSeo } from 'next-seo';
import { memo } from 'react';

import { Button } from '@air/primitive-button';

import { AppErrorBackground } from '~/components/AppError/AppErrorBackground';
import { Animated404 } from '~/components/NotFound/Animated404';
import { DocumentTitle } from '~/components/v2/components/shared/seo/DocumentTitle';
import { getAirTabTitle } from '~/components/v2/components/shared/seo/getAirTabTitle';
import { I18n } from '~/constants/I18n';
import { Routes } from '~/constants/routes';
import { NOT_FOUND_CONTENT } from '~/constants/testIDs';

export const NotFound = memo(() => (
  <>
    <DocumentTitle title={getAirTabTitle(I18n.notFoundPageTitle)} isFallback={false} />
    <NextSeo description={I18n.notFoundPageDescription} />
    <AppErrorBackground>
      <Animated404 />
      <h1 className="text-center font-semibold ads:text-primary text-16 text-gray-12">{I18n.notFoundPageTitle}</h1>
      <p
        className="mb-3 text-balance text-center ads:text-metadata text-12 text-gray-10"
        data-testid={NOT_FOUND_CONTENT}
      >
        {I18n.notFoundPageDescription}
      </p>

      <Button asChild size="extra-large" color="gray">
        <Link href={Routes.media.all}>Go back to Air</Link>
      </Button>
    </AppErrorBackground>
  </>
));

NotFound.displayName = 'NotFound';
